import React, { memo } from 'react';

interface FreshProps {
  color?: string;
  size?: number;
}

function Fresh({ color = '#666666', size = 14 }: FreshProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4707 10.5268C11.4707 11.4219 11.7372 12.2611 12.1751 12.9697C13.4316 11.683 14.7833 10.5641 16.2301 9.59441C13.7171 12.0746 11.7943 15.1515 10.5188 18.1725C9.31945 15.8788 7.81548 14.1259 6.71129 13.324C7.60606 13.697 8.44372 14.2191 9.2433 14.8159C9.45271 14.3683 9.56694 13.8648 9.56694 13.324C9.47175 8.2331 1 8.662 1 8.662C1.59017 9.44522 1.95188 10.4336 1.95188 11.4779V13.324C1.95188 15.3753 3.66527 17.0536 5.75941 17.0536C6.71129 17.0536 7.56799 16.7179 8.2343 16.1585C8.67217 17.296 8.99581 18.6573 9.16715 19.9441C10.3703 19.2727 11.7372 19.7016 12.2703 20C12.5939 17.7622 13.2602 15.6737 13.7171 14.4802C14.4406 14.9277 15.2973 15.1888 16.2301 15.1888C22.9885 15.1888 21.9414 4 21.9414 4C21.9414 4 21.0086 5.8648 18.1339 5.8648H16.2301C13.6029 5.8648 11.4707 7.95338 11.4707 10.5268Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(Fresh);
